/** FAQ dạng accordion cho người mới (nội dung ở download-app-content.js). */
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FAQS } from "../download-app-content";

function FaqRow({ q, a }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="border-b border-line last:border-b-0">
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="w-full flex items-center justify-between gap-3 text-left py-3"
            >
                <span className="font-semibold text-sm">{q}</span>
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`text-content-3 text-xs shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
                />
            </button>
            {open ? <p className="text-xs text-content-3 leading-relaxed pb-3 -mt-1">{a}</p> : null}
        </div>
    );
}

export default function DownloadFaqSection() {
    return (
        <div className="px-4 mt-7">
            <h2 className="font-bold text-lg mb-3 text-center md:text-left">Câu hỏi thường gặp</h2>
            <div className="bg-surface rounded-2xl px-4 border border-line shadow-sm">
                {FAQS.map((f) => (
                    <FaqRow key={f.q} q={f.q} a={f.a} />
                ))}
            </div>
        </div>
    );
}
